import React from 'react'
import './Footer.css'

const FooterV = (props) => {
  if (props.auth) {
    return (
      <div>
        <div className='main-footer-layer1'></div>
        <div className='main-footer-layer2'>
          © 2019 SALIS
        </div>
      </div>
    )
  } else {
    return (
      null
    )
  }

}

export default FooterV;
